import isUserHasProfile from "helpers/profileValidator";
import React, { useEffect, useState, useRef } from 'react';
import { useSelector } from 'react-redux';
import NumberFormat from 'react-number-format';
import Select from 'react-select';
import PropTypes from 'prop-types';
import {
  Container,
  Col,
  Row,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Label,
  FormGroup,
  Input,
  FormFeedback,
  Alert
} from 'reactstrap';
import { put, get, post } from 'helpers/requests';
import { BASE_URL, API, ESTADOS_DEUDOR, PROFILES, MAX_MONTOS_PERMITIDOS_BY_PROFILE, ADMIN_ROLES } from 'CONST';
import { formatRut, fdate, formatSpanishNumber } from '../../../helpers/helpers';
import { objectsToOptions, objectToOption } from '../../../helpers/selects';
import SafeBtn from '../../shared/SafeBtn';

const PosicionDeudorEdit = ({ openModal, datos, toggleModal, id, deudorIsForeign, monedaAsegurada }) => {
  const loginState = useSelector((state) => state.login);
  const [nombre, setNombre] = useState();
  const [telefono, setTelefono] = useState();
  const [email, setEmail] = useState();
  const [tamano, setTamano] = useState();
  const [opcionesTamano, setOpcionesTamano] =useState([]);
  const [rubro, setRubro] = useState();
  const [rubros, setRubros] = useState([]);
  const [estado, setEstado] = useState();
  const [techo, setTecho] = useState();
  const [motivo, setMotivo] = useState(null);
  const [motivosOpts, setMotivos] = useState([]);
  const [isValidTecho, setIsValidTecho] = useState(true);
  const [invalidTechoError, setInvalidTechoError] = useState(true);
  const [loading, setLoading] = useState(false);
  const [isValidMotivo, setIsValidMotivo] = useState(true);
  const [listaBlanca, setListaBlanca] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);

  // El rating es solo lectura aquí: se lee y se edita en BurosHub
  const [ratingVigente, setRatingVigente] = useState(null);
  const [organizationId, setOrganizationId] = useState(null);
  const [motivoVisible, setMotivoVisible] = useState(false);
  const [showAllActivities, setShowAllActivities] = useState(false);

  const [comentariosVisibleTecho, setComentariosVisibleTecho] = useState(false);
  const [comentariosTecho, setComentariosTecho] = useState('');
  const [initialTecho, setInitialTecho] = useState(null);
  const [initialEstadoValue, setInitialEstadoValue] = useState();
  const [initialMotivoId, setInitialMotivoId] = useState(null);
  const hasFetchedRef = useRef(false);

  useEffect(() => {
    if (openModal) {
      setComentariosVisibleTecho(false);
      setComentariosTecho('');
      setInitialTecho(null);
    } else {
      hasFetchedRef.current = false;
    }
  }, [openModal]);

  const opciones = [
    { label: 'Vigente', value: 'vigente' },
    { label: 'Lista Negra', value: 'bloqueado' },
  ];

  const opcionesListaBlanca = [
    { label: 'Sí', value: true },
    { label: 'No', value: false },
  ];

  const getMotivo = (res) => res.id === datos.motivo_bloqueo_id;
  const getRubro = (res) => res.id === datos.rubro_id;
  const getEstado = (res) => res.value === datos.estado;
  const getTamano = (res) => res.name === datos.tamano;
  const getInput = (input) => input || '---';

  const fetchData = (apiUrl) => {
    let url = apiUrl;
    let data = [];
    get(`${BASE_URL}${API.ratingBuroshub}/?rut=${encodeURIComponent(datos.rut)}`)
      .then(response => {
        setRatingVigente(response && response.length > 0 ? response[0] : null);
      })
      .catch(error => console.error('Error al obtener el rating desde BurosHub:', error));
    return get(url)
      .then(response => {
        data = response.results;
        url = response.next;
        if(url !== '' && url !== null){
          return fetchData(url).then((res) => data.concat(res));
        }
        return data;
    })
  }

  const isSettingInitialData = useRef(false);

const setTechoVigente = (value) => {
    
    if (value === null || value === undefined) {
      setTecho(null);
    }
    else {
      setTecho(value);
      
      if (!isSettingInitialData.current) {
        if (initialTecho === null || initialTecho === undefined) {
          console.log('Setting initialTecho to:', value);
          setInitialTecho(value);
          setComentariosVisibleTecho(false);
        }
        else if (value !== initialTecho) {
          console.log('Value differs from initial, showing comments');
          setComentariosVisibleTecho(true);
        }
        else {
          setComentariosVisibleTecho(false);
        }
      }
    }
    
    const PROFILE_TO_MONTO_KEY = {
        [PROFILES.analistaRiesgoCreditoJr]: 'analistaRiesgoCreditoJr',
        [PROFILES.analistaRiesgoCreditoSr]: 'analistaRiesgoCreditoSr',
        [PROFILES.subgerenteRiesgoCredito]: 'subgerenteRiesgoCredito',
        [PROFILES.gerenteRiesgoCredito]: 'gerenteRiesgoCredito',
        [PROFILES.actuariado]: 'actuariado',
      };

    if (value !== null && value !== undefined) {
      // Admin roles pasa todo
      if (isUserHasProfile(ADMIN_ROLES)) {
        setIsValidTecho(true);
        return;
      }
    
      const limitesByMoneda = MAX_MONTOS_PERMITIDOS_BY_PROFILE[monedaAsegurada];

      const montosAplicables = Object.entries(PROFILE_TO_MONTO_KEY)
        .filter(([profile]) => isUserHasProfile([profile]))
        .map(([, montoKey]) => limitesByMoneda[montoKey]);
    
      if (montosAplicables.length > 0) {
        // El PERFIL más restrictivo aplica
        const maxMonto = Math.min(...montosAplicables);
        if (value <= maxMonto) {
          setIsValidTecho(true);
        } else {
          setIsValidTecho(false);
          setInvalidTechoError(`No tiene permitido ingresar Techo Vigente mayor a ${formatSpanishNumber(maxMonto)} ${monedaAsegurada}.`);
        }
      }
    }
  }

  const setDataEdition = () => {
    isSettingInitialData.current = true;
    
    setNombre(datos.contacto);
    setTelefono(datos.phone);
    setEmail(datos.email);

    const techoValue = datos.techo_vigente;
    setTecho(techoValue);
    setInitialTecho(techoValue);
    setComentariosVisibleTecho(false);
    
    setListaBlanca(datos.lista_blanca === true);

    const currentEstado = opciones.find(getEstado);
    setEstado(currentEstado);
    setInitialEstadoValue(datos.estado);

    if (datos.motivo_bloqueo_id) {
      setInitialMotivoId(datos.motivo_bloqueo_id);
    }
    
    setTimeout(() => {
      isSettingInitialData.current = false;
    }, 100);
  }

  useEffect(() => {
    if (!datos.rut || !openModal) return;

    if (!hasFetchedRef.current) {
        get(`${BASE_URL}${API.motivosResolucion}/?ordering=descripcion`).then((response) => {
            setMotivos(objectsToOptions(response));
            if (datos.motivo_bloqueo_id) {
                const motivoObj = response.find(getMotivo);
                setMotivo(objectToOption(motivoObj));
            } else {
                setMotivo(null);
            }
        });
        get(`${BASE_URL}${API.actividadEconomica}/?ordering=descripcion`).then((response) => {
            setRubros(objectsToOptions(response));
            setRubro(datos.rubro_id ? objectToOption(response.find(getRubro)) : null);
        });
        fetchData(`${BASE_URL}${API.tamanoEmpresa}/?ordering=descripcion`).then((response) => {
            setOpcionesTamano(objectsToOptions(response,false,false,'name'));
            const isInSelector = response.find(getTamano);
            if (isInSelector){
                setTamano(datos.tamano ? objectToOption(response.find(getTamano), 'name') : null);
            }
            else {
                setTamano(null);
            }
        });
        setDataEdition();
        hasFetchedRef.current = true;
    }
  }, [datos.rut, datos.motivo_bloqueo_id, datos.rubro_id, datos.tamano, openModal]);

  // Obtener organization_id (necesario para el historial de techo)
  useEffect(() => {
    if (datos.organization_id) {
      setOrganizationId(datos.organization_id);
      return;
    }
    if (!datos.rut) return;
    get(`${BASE_URL}${API.organization}/?rut=${datos.rut}`)
      .then(orgResponse => {
        if (orgResponse && orgResponse.results && orgResponse.results.length > 0) {
          setOrganizationId(orgResponse.results[0].id);
        } else {
          console.error('No se encontró organización para el rut proporcionado');
        }
      })
      .catch(error => {
        console.error('Error al obtener la organización:', error);
      });
  }, [datos.rut, datos.organization_id]);

  useEffect(() => {
    if(estado) {
      setIsValidMotivo(true);
      if(estado.value === ESTADOS_DEUDOR.bloqueado && !motivo) {
        setIsValidMotivo(false);
      }
    }
  }, [motivo, estado])

  const changeStatus = (value) => {
    setEstado(value);
    if (value.value === ESTADOS_DEUDOR.vigente){
      setMotivo(null);
      setMotivoVisible(false);
    } else if (value.value === ESTADOS_DEUDOR.bloqueado) {
      setMotivoVisible(true);
    }
  }

  const onCloseModal = () => {
    hasFetchedRef.current = false;
    toggleModal();
  };

  const onClick = async () => {
    setLoading(true);
    setErrorMessage(null);

    if (comentariosVisibleTecho && organizationId){
      const payloadTecho = {
        organization: organizationId,
        comentarios: comentariosTecho,
        techo_vigente: techo,
      }
      const url = `${BASE_URL}${API.historialtecho}/`;

      await post(url, payloadTecho);
    }

    const data = {
      rut: datos.rut,
      contacto: nombre,
      phone: telefono,
      email,
      tamano,
      estado: estado.value,
      techo_vigente: techo,
      lista_blanca: listaBlanca,
    };

    if (rubro) {
      data.rubro_id = rubro.value.id;
    }
    if (estado.value === ESTADOS_DEUDOR.bloqueado) {
      
      data.motivo_bloqueo_id = motivo?.value?.id || datos.motivo_bloqueo_id;
    }
    if (tamano) {
      data.tamano = tamano.label;
    }

    try {
      await put(`${BASE_URL}${API.deudor}/${id}/`, data);

      const estadoChanged = estado.value !== initialEstadoValue;
      const currentMotivoId = estado.value === ESTADOS_DEUDOR.bloqueado
        ? (motivo?.value?.id || datos.motivo_bloqueo_id)
        : null;
      const motivoChanged = currentMotivoId !== initialMotivoId;
      if (estadoChanged || motivoChanged) {
        let motivoDescripcion = null;

        if (estado.value === ESTADOS_DEUDOR.bloqueado) {
          motivoDescripcion = motivo?.value?.descripcion || null;
          if (!motivoDescripcion && datos.motivo_bloqueo_id) {
            const motivoObj = motivosOpts.find(opt => opt.value.id === datos.motivo_bloqueo_id);
            motivoDescripcion = motivoObj?.value?.descripcion || null;
          }
        }
        const dataHistorialEstado = {
          updating_user_id: parseInt(loginState.user.sub, 10),
          estado: estado.value,
          motivo: motivoDescripcion,
          motivo_bloqueo_id: currentMotivoId,
          deudor: parseInt(id, 10)
        }
        await post(`${BASE_URL}${API.historialestadosdeudores}`, dataHistorialEstado);
      }

      toggleModal();
    } catch (error) {    
      if (error instanceof Response) {
        try {
          const errorData = await error.json();
          
          if (error.status === 400) {
            if (errorData.lista_blanca?.[0]) {
              setErrorMessage(errorData.lista_blanca[0]);
            } else if (errorData.estado?.[0]) {
              setErrorMessage(errorData.estado[0]);
            } else {
              setErrorMessage("Error de validación");
            }
          } else {
            setErrorMessage("Error al actualizar el deudor");
          }
        } catch (parseError) {
          setErrorMessage("Error de conexión");
        }
      } else {
        setErrorMessage("Error de conexión");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal isOpen={openModal} style={{maxWidth: '1100px', width: '80%'}} type="modal-warning warning-container">
      <ModalHeader>
        Editar deudor
      </ModalHeader>
      <ModalBody>
        {errorMessage && (
          <Alert color="danger" style={{ margin: '15px 0' }}>
            {errorMessage}
          </Alert>
        )}
        <Container>
          <Row style={{ marginBottom: '1rem' }}>
            <Col md="6">
              <FormGroup row>
                <Label sm={5} for="rutDeudor">
                  {deudorIsForeign ? 'N° Documento Deudor' : 'RUT Deudor'}
                </Label>
                <p id="rutDeudor" style={{ paddingLeft: 0, paddingBottom: 10 }}>{deudorIsForeign ? datos.rut : formatRut(datos.rut)}</p>
              </FormGroup>
              {deudorIsForeign && (
                <FormGroup row>
                  <Label sm={5} for="paisDeudor">
                    País Deudor
                  </Label>
                  <p id="paisDeudor" style={{ paddingLeft: 0, paddingBottom: 10 }}>{datos.pais.name}</p>
                </FormGroup>
              )}
              <FormGroup row style={{ flexWrap: 'nowrap' }}>
                <Label sm={5} for="razonSocial">
                  Razón Social
                </Label>
                <p id="razonSocial" style={{ paddingLeft: 0, paddingBottom: 10 }}>{datos.name}</p>
              </FormGroup>
              <FormGroup row>
                <Label sm={5} for="fechaInicio">
                  Fecha inicio actividades
                </Label>
                <p id="fechaInicio" style={{ paddingLeft: 0, paddingBottom: 10 }}>
                  {getInput(fdate(datos.inicio_actividad))}
                </p>
              </FormGroup>
              <FormGroup row style={{ flexWrap: 'nowrap' }}>
                <Label sm={5} for="actividad">
                  Actividad
                </Label>
                <Col sm={7}>
                  {datos.actividad && datos.actividad.length > 0 ? (
                    <div>
                      <ul className="list-unstyled mb-1">
                        {(showAllActivities ? datos.actividad : datos.actividad.slice(0, 1)).map((actividad) => (
                          <li key={actividad.codigo || actividad.actividad_economica} className="dot-item">
                            • 
                            {' '} 
                            {actividad.actividad_economica}
                          </li>
                        ))}
                      </ul>
                      {datos.actividad.length > 1 && (
                        <Button
                          color="link"
                          size="sm"
                          className="p-0 text-primary mb-3"
                          onClick={() => setShowAllActivities(prev => !prev)}
                        >
                          {showAllActivities ? 'Mostrar menos' : `Mostrar ${datos.actividad.length - 1} más`}
                        </Button>
                      )}
                    </div>
                  ) : (
                    '---'
                  )}
                </Col>
              </FormGroup>
              <FormGroup row>
                <Label sm={5} for="estadoDeudor">
                  Estado Deudor
                </Label>
                <Col sm={7} style={{ paddingLeft: 0, paddingBottom: 10 }}>
                  <Select
                    id="estadoDeudor"
                    width="100%"
                    height="50%"
                    options={opciones}
                    value={estado}
                    onChange={(event) => changeStatus(event)}
                  />
                </Col>
              </FormGroup>
              {motivoVisible && (
                <FormGroup row>
                  <Label sm={5} for="motivo">
                    Motivo de ingreso a Lista Negra
                  </Label>
                  <Col sm={7} style={{ paddingLeft: 0, paddingBottom: 15 }}>
                    <Select
                      id="motivo"
                      width="100%"
                      height="50%"
                      options={motivosOpts}
                      value={motivo}
                      onChange={(event) => setMotivo(event)}
                    />
                    {!motivo && (
                      <FormFeedback>Debe indicar el motivo de ingreso a Lista Negra</FormFeedback>
                    )}
                  </Col>
                </FormGroup>
              )}
              <FormGroup row>
                <Label sm={5} for="listaBlanca">
                  Lista Blanca
                </Label>
                <Col sm={7} style={{ paddingLeft: 0, paddingBottom: 10 }}>
                  <Select
                    id="listaBlanca"
                    width="100%"
                    height="50%"
                    options={opcionesListaBlanca}
                    value={opcionesListaBlanca.find(option => option.value === listaBlanca)}
                    onChange={(event) => setListaBlanca(event.value)}
                  />
                </Col>
              </FormGroup>
              <FormGroup row>
                <Label sm={5} for="rating">
                  Rating
                </Label>
                <Col sm={7} style={{ paddingLeft: 0, paddingBottom: 10 }}>
                  <Input id="rating" type="text" value={ratingVigente ? `${ratingVigente.valor}${ratingVigente.intervalo_nota ? ` (${ratingVigente.intervalo_nota})` : ''}` : '---'} disabled />
                  <small className="text-muted">El rating se edita en BurosHub.</small>
                </Col>
              </FormGroup>
            </Col>
            <Col>
              <FormGroup row>
                <Label sm={5} for="rubro">
                  Rubro
                </Label>
                <Col sm={7} style={{ paddingLeft: 0, paddingBottom: 15 }}>
                  <Select
                    id="rubro"
                    width="100%"
                    height="50%"
                    options={rubros}
                    value={rubro}
                    onChange={(event) => setRubro(event)}
                  />
                </Col>
              </FormGroup>
              <FormGroup row>
                <Label sm={5} for="tamanno">
                  Tamaño
                </Label>
                <Col sm={7} style={{ paddingLeft: 0, paddingBottom: 15 }}>
                  <Select
                    id="tamanno"
                    options={opcionesTamano}
                    value={tamano}
                    onChange={(event) => setTamano(event)}
                  />
                </Col>
              </FormGroup>
              <FormGroup row>
                <Label sm={5} for="emailContacto">
                  Email contacto
                </Label>
                <Col sm={7} style={{ paddingLeft: 0, paddingBottom: 15 }}>
                  <Input
                    id="emailContacto"
                    type="text"
                    value={email || ""}
                    onChange={(event) => setEmail(event.target.value)}
                  />
                </Col>
              </FormGroup>
              <FormGroup row>
                <Label sm={5} for="telefonoContacto">
                  Teléfono contacto
                </Label>
                <Col sm={7} style={{ paddingLeft: 0, paddingBottom: 15 }}>
                  <Input
                    id="telefonoContacto"
                    type="text"
                    value={telefono || ""}
                    onChange={(event) => setTelefono(event.target.value)}
                  />
                </Col>
              </FormGroup>
              <FormGroup row>
                <Label sm={5} for="nombreContacto">
                  Nombre Contacto
                </Label>
                <Col sm={7} style={{ paddingLeft: 0,  paddingBottom: 15 }}>
                  <Input
                    id="nombreContacto"
                    type="text"
                    value={nombre || ""}
                    onChange={(event) => setNombre(event.target.value)}
                  />
                </Col>
              </FormGroup>
              <FormGroup row>
                <Label sm={5} for="techo">
                  Techo Vigente ({monedaAsegurada})
                </Label>
                <Col sm={7} style={{ paddingLeft: 0, paddingBottom: 15 }}>
                  <NumberFormat
                    className="form-control"
                    name="techo"
                    id="techo"
                    value={techo}
                    onValueChange={({floatValue}) => setTechoVigente(floatValue)}
                    thousandSeparator="."
                    decimalScale="0"
                    decimalSeparator={false}
                    allowNegative={false}
                    renderText={(value) => <p className="small-form-value">{value}</p>}
                  />
                  {!isValidTecho && (
                    <FormFeedback style={{ fontSize: "12px", float:"right" }}>
                      <span>{invalidTechoError}</span>
                    </FormFeedback>
                  )}
                </Col>
              </FormGroup>
              {comentariosVisibleTecho && (
                <FormGroup row>
                  <Label sm={5} for="comentarios">
                    Comentarios Techo
                  </Label>
                  <Col sm={7} style={{ paddingLeft: 0, paddingBottom: 10 }}>
                    <Input
                      type="textarea"
                      id="comentarios"
                      value={comentariosTecho}
                      maxLength="220"
                      onChange={(e) => setComentariosTecho(e.target.value)}
                    />
                    {!comentariosTecho && (
                      <FormFeedback>Ingrese comentarios sobre dicho cambio de techo</FormFeedback>
                    )}
                  </Col>
                </FormGroup>
              )}
            </Col>
          </Row>
        </Container>
      </ModalBody>
      <ModalFooter>
        <Button className="warning-cancel mr-auto" onClick={() => onCloseModal()}>
          Cancelar
        </Button>
        <SafeBtn
          className="warning-accept"
          onClick={() => onClick()}
          disabled={
            !isValidTecho || 
            (estado?.value === ESTADOS_DEUDOR.bloqueado && estado?.value !== initialEstadoValue && !motivo) || 
            (comentariosVisibleTecho && !comentariosTecho) || 
            loading
          }
          loading={loading}
        >
          Aceptar
        </SafeBtn>
      </ModalFooter>
    </Modal>
  );
};

PosicionDeudorEdit.propTypes = {
  openModal: PropTypes.bool.isRequired,
  id: PropTypes.string.isRequired,
  datos: PropTypes.shape({
    rut: PropTypes.string,
    name: PropTypes.string,
    estado: PropTypes.string,
    motivo_bloqueo_id: PropTypes.number,
    inicio_actividad: PropTypes.string,
    actividad: PropTypes.arrayOf(
      PropTypes.object,
    ),
    rubro_id: PropTypes.number,
    tamano: PropTypes.string,
    email: PropTypes.string,
    phone: PropTypes.string,
    contacto: PropTypes.string,
    score: PropTypes.number,
    techo_vigente: PropTypes.number,
    lista_blanca: PropTypes.bool,
    organization_id: PropTypes.number,
    pais: PropTypes.shape({
      name: PropTypes.string,
      code: PropTypes.string,
    }),
  }).isRequired,
  toggleModal: PropTypes.func.isRequired,
  deudorIsForeign: PropTypes.bool,
  monedaAsegurada: PropTypes.string,
};

PosicionDeudorEdit.defaultProps = {
  deudorIsForeign: false,
  monedaAsegurada: 'UF',
};

export default PosicionDeudorEdit;